/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rowplusoneshint3Inputs */

const en_rowplusoneshint3 = /** @type {(inputs: Rowplusoneshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests say how many come along.`)
};

const de_rowplusoneshint3 = /** @type {(inputs: Rowplusoneshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste geben an, wie viele mitkommen.`)
};

/**
* | output |
* | --- |
* | "Guests say how many come along." |
*
* @param {Rowplusoneshint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const rowplusoneshint3 = /** @type {((inputs?: Rowplusoneshint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rowplusoneshint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rowplusoneshint3(inputs)
	return de_rowplusoneshint3(inputs)
});
export { rowplusoneshint3 as "rowPlusOnesHint" }